import { create } from "lodash";

const Translation = {
  access_point: "搬出入ゲート",
  accessPoints: "搬出入ゲート",
  vehicle_type: "車両タイプ",
  vehicleTypes: "車両タイプ",
  booking_date: "予定日",
  booking_ref: "予約ID",
  error_something_went_wrong: "何かがうまくいかなかった...",
  filters: "フィルター",
  filter: "フィルター",
  Status: "スターテス",
  statuses: "スターテス",
  Projects: "プロジェクト",
  Organization: "組織",
  organizations: "組織",
  Organizations: "組織",
  Tracking: "追跡",
  vehicle_tracking: "車両追跡",
  vehicle_tracking_description:
    "車両追跡およびモバイル ルーティング機能へのアクセスを有効にする",
  reset_filter: "リセットフィルター",
  apply_filter: "フィルターを適用します",
  users: "ユーザー",
  total_user: "総ユーザー",
  total_Organization: "総組織",
  active_users: "アクティブユーザー",
  clear_all: "すべてクリア",
  showing: "表示",
  no_sdata_found: "何もデータが見つかりませんでした",
  entries_of: "のエントリ",
  entries: "エントリ",
  search_by_User_parameter_in_userlist:
    "ユーザー名、組織名、メールアドレスで検索",
  search_by_project_name: "プロジェクト名で検索します",
  organization_Name: "組織名",
  organization_Admin: "組織管理者",
  Country: "国",
  associated_Projects: "関連プロジェクト",
  others: "その他",
  search_by_organization_name: "組織名で検索します",
  close: "近い",
  tap_to_edit: "タップしてプロファイル画像を編集します",
  first_name_required: "名が必要です",
  last_name_required: "姓が必要です",
  email_name_required: "メールが必要です",
  phone_name_required: "電話が必要です",
  email: "Eメール",
  phone: "電話",
  save_details: "詳細を保存します",
  organization_role: "組織の役割",
  user_status: "ユーザーステータス",
  global_user_status: "グローバル管理ステータス",
  personal_details: "個人的な詳細",
  organization_created: "正常に作成された組織",
  select_country: "国を選択",
  org_name_required: "組織名が必要です",
  address_required: "アドレス名が必要です",
  city_required: "町/都市が必要です",
  saved_successfully: "詳細を正常に保存します",
  organization_details: "組織の詳細",
  address_line_1_required: "address1が必要です",
  address_line_2_required: "address2が必要です",
  zip_required: "zipが必要です",
  country_required: "国が必要です",
  organization_logo: "組織ロゴ",
  statement_info_text:
    "ステートメントテキストにリンクを含めるには、次の形式を使用します{link text、https://link.com}。",
  question_required: "質問が必要です",
  create_project: "プロジェクトを作成します",
  user_data_saved_successfully: "ユーザー情報を正常に更新しました",
  section_visibility: "セクションの可視性",
  project_setting: "プロジェクト設定",
  project_settings_description:
    "プロジェクト設定は、「Pro」機能と統合にアクセスして構成できる場所です。これを有効にすると、プロジェクト管理者がプロジェクト設定領域が表示され、アクセス可能になります。",
  integration: "統合",
  integration_description:
    "統合は、サードパーティの統合を有効にして構成できる場所です。これを有効にすると、統合領域が目に見えるようになり、プロジェクト管理者がアクセスできます。統合はプロジェクト設定に含まれており、両方とも統合領域にアクセスするためにアクティブでなければなりません。",
  enable_pro_settings: "プロの設定を有効にします",
  procore_daily_log: "Procore Daily Log",
  procore_daily_log_description:
    "Procore Daily Logを構成するためにアクセスを有効にします。この機能は、Procoreの統合に依存しています。",
  enable_integrations: "統合を有効にします",
  fors_validation: "FORS検証",
  fors_validation_description: "FORS検証の構成にアクセスを有効にします。",
  procore: "プロコール",
  procore_description: "Procore統合の構成にアクセスできるようにします。",
  feature_updated: "正常に更新された機能",
  integrations_updated: "統合を正常に更新しました",
  verification: "検証",
  organization_state: "組織状態",
  select_org_state: "組織状態を選択してください",
  verified_email_domain: "検証済みの電子メールドメイン",
  email_domain_required: "検証済みの電子メールドメインを選択してください",
  verified: "検証",
  unverified: "未検証",
  scheduling: "スケジューリング",
  field: "分野",
  edit: "編集",
  duration: "間隔",
  core_fields: "コアフィールド",
  active: "アクティブ",
  Active: "アクティブ",
  Inactive: "非アクティブ",
  mandatory: "必須",
  flexible_fields: "柔軟なフィールド",
  add_new_field: "新しいフィールドを追加します",
  core_field_saved_success_fully: "コアフィールドの詳細を正常に保存します",
  error_login_again: "認証資格情報は提供されていません",
  vehicle_types: "車両タイプ",
  included: "含まれています",
  cancel: "キャンセル",
  save: "保存",
  change_associated_organization: "関連する組織を変更します",
  confirm: "確認",
  new_organization: "新しい組織",
  changed_organization: "組織の変更に成功します",
  no_data_found: "何もデータが見つかりませんでした",
  collapse: "崩壊",
  new_project: "新しいプロジェクト",
  field_removed: "フィールドが削除されました",
  this_field_is_active: "このフィールドはアクティブです",
  this_field_is_mandatory: "このフィールドは必須です",
  core_field_saved: "コアフィールドの詳細を正常に保存します",
  search: "検索",
  from: "から",
  to: "に",
  today: "今日",
  yesterday: "昨日",
  start_date_greater_than_end_date: "開始日は終了日より大きくはありません",
  back: "戻る",
  account_created: "アカウントが作成されました",
  last_login: "前回のログイン",
  link: "リンク",
  status: "スターテス",
  First_Name: "ファーストネーム",
  Last_Name: "苗字",
  Email_Address: "電子メールアドレス",
  Associated_Organization: "関連する組織",
  Associated_Projects: "関連プロジェクト",
  account_manager: "アカウントマネージャー",
  organization: "組織",
  apply_filters: "フィルターを適用します",
  next: "次",
  previous: "前",
  no_activity_found: "アクティビティは見つかりません",
  create_organization: "新しい組織を追加します",
  forgot_password: "パスワードをお忘れですか",
  welcometext_forgot:
    "メールを入力してください。パスワードをリセットする手順をお送りします。",
  backtologin: "ログインに戻る",
  submit: "送信",
  error_email_required: "メールが必要です",
  error_valid_email: "有効なメールアドレスを入力してください",
  welcometext: "Voyage Controlへようこそ",
  pls_login: "ログインしてください",
  password: "パスワード",
  login: "ログイン",
  booking_type: "予約タイプ",
  site_defaults: "サイトのデフォルト",
  project: "プロジェクト",
  total_project: "総プロジェクト",
  project_status: "プロジェクトステータス",
  active_project: "アクティブなプロジェクト",
  site_settings: "サイト設定",
  automatic_approval: "自動承認",
  automatic_approval_description:
    "すべての予約は、作成後に自動的に承認されます。",
  unauthorize_user: "アクセス拒否",
  edit_project_details: "プロジェクトの詳細を編集します",
  credential_not_provided: "認証資格情報は提供されていません",
  region_not_available: "現在の地域は利用できません",
  btn_back: "戻る",
  date_created: "作成された日付",
  local_site_time: "現場での現地時間",
  successfully_edit_contact: "連絡先を正常に編集します",
  invalid_url: "有効なURLを入力してください",
  project_owner_email_address: "プロジェクト所有者のメールアドレス",
  project_edited: "プロジェクトの詳細は編集されました",
  please_contact_selected_owner_to_accept_the_invitation:
    "招待状を受け入れるには、選択した所有者に連絡してください",
  please_select_owner: "所有者を選択してください",
  success_fully_added_contact: "連絡先を正常に追加します",
  image_uploaded: "正常にアップロードされた画像",
  contact_deleted: "削除された連絡先",
  project_organization: "プロジェクト組織",
  select_site: "サイトを選択します",
  any_integration_lost: "統合構成が失われる場合",
  disable: "無効にする",
  go: "行く",
  actions: "行動",
  go_to_project: "プロジェクトに移動します",
  project_settings_updated: "プロジェクト設定が更新されました",
  invalid_date: "無効な日付",
  added_flexible_field_data: "柔軟なフィールドデータを追加します",
  title_is_required: "タイトルが必要です",
  question_is_required: "質問が必要です",
  option_is_required: "オプションが必要です",
  title: "タイトル*",
  question: "質問*",
  statement: "声明*",
  field_type: "フィールドタイプ*",
  options: "オプション",
  add: "追加",
  add_new_option: "新しいオプションを追加します",
  edit_field: "フィールドを編集します",
  add_field: "フィールドを追加します",
  free_text: "フリーテキスト",
  confirm_text: "これを永久に削除することを確認してください",
  can_not_undo: "このアクションを元に戻すことはできません",
  delete: "消去",
  select_role: "役割を選択します",
  user_removed: "ユーザーは組織から削除されます",
  organization_updated: "組織の役割が更新されました",
  no_user: "ユーザーは見つかりませんでした",
  flex_fields_added: "正常に柔軟なフィールドを追加します",
  edit_flex_field: "柔軟なフィールドを編集します",
  add_flex_field: "新しい柔軟なフィールドを追加します",
  org_name: "組織名",
  address_line_1: "住所1",
  address_line_2: "住所2",
  town_city: "町/都市",
  town_city_required: "町/都市が必要です",
  zip_code: "郵便番号",
  zip_code_required: "zipcodeが必要です",
  country: "国",
  reset_password: "パスワードを再設定する",
  welcometext_reset: "パスワードには少なくとも6文字が必要です",
  confirmpassword: "パスワードを認証する",
  error_password_required: "パスワードが必要",
  error_confirm_password_required: "パスワードを確認する必要があります",
  error_password_upper: "少なくとも1つの大文字",
  error_password_lower: "少なくとも1つの小文字",
  error_password_number: "少なくとも1桁",
  error_password_special: "少なくとも1つの特別なキャラクター",
  error_password_min: "最低6文字",
  error_password_max: "最大16文字",
  error_valid_password:
    "少なくとも1つの大文字、少なくとも1つの小文字、少なくとも1桁、少なくとも1つの特殊文字、最低6文字、最大16文字。",
  error_password_not_match: "パスワードが一致しません",
  success_message: "パスワードリセットを正常にリセットします",
  error_language_required: "言語が必要です",
  error_dateformat_required: "日付形式が必要です",
  error_timeformat_invalid: "TimeFormatが必要です",
  error_startday_required: "初日が必要です",
  error_status_required: "ステータスが必要です",
  details_heading_text: "プロジェクトの詳細",
  project_name: "プロジェクト名",
  project_lead: "プロジェクトリード",
  project_owner: "プロジェクトオーナー",
  project_org: "プロジェクト組織",
  project_add: "住所",
  edit_project_detail: "プロジェクトの詳細を編集します",
  heading_contact: "連絡先の詳細",
  logo: "ロゴ",
  home_page_banner: "ホームバナー",
  details_image_text: "画像とホーム画面",
  label_sitename: "プロジェクト名",
  label_siteadd: "プロジェクトアドレス",
  label_siteOwner: "プロジェクトオーナー",
  label_siteOrg: "プロジェクト組織",
  label_accManager: "アカウントマネージャー",
  label_hubspot: "hubspotリンク",
  label_home_banner: "ホームバナー",
  label_region: "領域",
  error_region_required: "地域が必要です",
  label_home_screen_message: "ホーム画面メッセージ",
  error_image_invalid: "有効な画像ファイルをアップロードしてください",
  error_siteLogo_required: "サイトのロゴが必要です",
  error_homebanner_required: "バナー画像が必要です",
  error_sitename_required: "プロジェクト名が必要です",
  error_siteadd_required: "プロジェクトアドレスが必要です",
  error_siteowner_required: "プロジェクト所有者が必要です",
  error_siteorg_required: "プロジェクト組織が必要です",
  error_acc_manager_required: "アカウントマネージャーが必要です",
  error_hubspot_url: "HubSpot URLが必要です",
  error_homemessage_required: "ホーム画面メッセージが必要です",
  contact_heading_text: "連絡先",
  add_contact: "新しい連絡先を追加します",
  edit_contact: "連絡先を編集します",
  label_name: "名前",
  label_position: "位置",
  label_phone: "電話番号（オプション）",
  btn_add: "追加",
  btn_remove: "削除",
  btn_edit: "編集",
  btn_save: "保存",
  error_name_required: "名前が必要です",
  error_position_required: "位置が必要です",
  error_valid_phonenumber: "有効な電話番号を入力してください",
  error_required_phone: "電話が必要です",
  drag_and_drop: "ファイルをドラッグアンドドロップします",
  browse_file: "ブラウズファイル",
  image_uploading: "画像のアップロード",
  select: "選択する",
  address: "住所",
  hubspot: "hubspot",
  "pre-live": "ライブ",
  paused: "一時停止",
  finished: "終了した",
  invited: "招待",
  Invited: "招待",
  restricted: "制限付き",
  blocked: "ブロックされています",
  Approved: "承認された",
  Blocked: "ブロックされました",
  Pending: "保留中",
  logout: "ログアウト",
  email_optional_label: "メールアドレス（オプション）",
  project_information: "プロジェクト情報",
  project_settings: "プロジェクト設定",
  booking_fields: "予約フィールド",
  project_users: "プロジェクトユーザー",
  project_activity: "プロジェクトアクティビティ",
  emission_tracking: "はいしゅつりょう の ついせき",
  equipment_emissions: "機器の排出量",
  emissionFactor: "排出係数",
  vehicle_emissions: "車両の排出量",
  equipment_master_add: "設備を追加",
  vehicle: "車両",
  milesgallons_or_kmLitres: "マイル/ガロン または キロメートル/リットル",
  emission_factor: "排出係数",
  equipment: "機器",
  emissions: "排出量",
  category: "カテゴリ",
  brand: "ブランド",
  model: "モデル",
  emission_settings: "排出設定",
  transport_round_trip_settings: "輸送往復設定",
  organization_info: "組織情報",
  organization_users: "組織ユーザー",
  organization_activity: "組織活動",
  user_information: "ユーザー情報",
  associated_organizations: "関連組織",
  associated_projects: "関連プロジェクト",
  user_activity: "ユーザーアクティビティ",
  vehicles_manager: "車両マネージャー",
  vehicle_type_added: "車種を追加しました",
  vehicle_type_updated: "車両タイプを更新しました",
  vehicle_type_deleted: "削除された車種",
  no_vehicles_found: "車種が見つかりません",
  add_vehicle: "新しい車両タイプを追加",
  multi_vehicle_description:
    "マルチチェキンの予約を使用すると、それぞれの個別の予約をするのではなく、現場に到着する車両の数を定義できます。",
  recurring_description:
    "予約をスケジュールして、毎週または月に毎日繰り返すことができます。たとえば、毎週のゴミコレクション。",
  resource_only_description:
    "アクセスポイントで予約スペースをとることなく、利用可能なリソースのみを予約できます。",
  multi_resource_description:
    "サイト単位で、1つの予約に対して複数のリソースを割り当て・管理する機能を有効または無効に設定できます。この機能を有効にすると、ユーザーは1つの予約に複数のリソースを選択して割り当てることができます。無効にした場合、予約に割り当てられるリソースは1つに制限されます",  
  multi_vehicle: "マルチ車",
  recurring: "繰り返し",
  resource_only: "リソースのみ",
  multi_resource: "複数のリソース",
  resource: "リソース",
  invite_user: "ユーザーを招待します",
  add_another: "別のものを追加します",
  role: "役割",
  project_admin: "プロジェクト管理者",
  project_manager: "プロジェクトマネージャ",
  project_user: "プロジェクトユーザー",
  send_invite: "招待を送る",
  invite_sent: "招待状に正常に送信されました",
  security_guard: "警備員",
  view_only: "表示のみ",
  project_senior_user: "プロジェクトシニアユーザー",
  profile: "プロフィール",
  language: "言語",
  booking_contact: "予約の連絡先",
  comments: "コメント",
  phone_number: "電話番号",
  project_role: "プロジェクトの役割",
  project_role_updated: "プロジェクトの役割が更新されました",
  Van: "バン",
  "18 Wheeler": "18ウィーラー",
  "Box Truck": "ボックストラック",
  "Car + Trailer": "車 +トレーラー",
  Car: "車",
  "Concrete Truck": "コンクリートトラック",
  "Dump Truck": "ダンプトラック",
  "Flatbed Truck": "フラットベッドトラック",
  "Garbage Truck": "ごみ収集車",
  "Mobile Crane": "モバイルクレーン",
  Other: "他の",
  "Pickup Truck": "ピックアップトラック",
  "Pump Truck": "ポンプトラック",
  Tanker: "タンカー",
  "Articulated Vehicle": "明確な車両",
  "Raised Floor Trailer": "高床トレーラー",
  "Low Floor Trailer": "低床トレーラー",
  "15t Flat Truck": "15t平車",
  "15t Unic Truck": "15tユニック車",
  "10t Flat Truck": "10t平車",
  "10t Unic Truck": "10tユニック車",
  "8t Flat Truck": "8t平車",
  "8t Unic Truck": "8tユニック車",
  "4t Flat Truck": "4t平車",
  "4t Unic Truck": "4tユニック車",
  "2t Flat Truck": "2t平車",
  "Concrete Mixer Truck": "生コン車",
  "16t Rough Terrain-Crane": "16tラフテレーンクレーン",
  "25t Rough Terrain-Crane": "25tラフテレーンクレーン",
  "50t Rough Terrain-Crane": "50tラフテレーンクレーン",
  "65t Rough Terrain-Crane": "65tラフテレーンクレーン",
  "10t dump truck": "ダンプカー10t",
  "10t Dump Truck": "ダンプカー10t",
  "10t arm roll": "アームロール10t",
  "10t Arm Roll": "アームロール10t",
  "4t arm roll": "アームロール4t",
  "4t Arm Roll": "アームロール4t",
  "WIRE FEEDER": "ワイヤーフィーダー",
  "Excavator": "掘削機",
  "TRUCK": "トラック",
  "WELDER": "溶接機",
  "TELEHANDLERS": "テレハンドラー",
  "FORKLIFTS": "フォークリフト",
  "SCISSOR LIFTS": "シザーリフト",
  "ARTICULATING BOOMS": "屈曲ブームリフト",
  "Loader": "ローダー",
  "Truck Crane": "トラッククレーン",
  "Rough Terrain Crane": "ラフテレーンクレーン",
  "Crawler Crane": "クローラークレーン",
  "Boom Lift": "ブームリフト",
  "Straight Forklift": "ストレートフォークリフト",
  "Reach Forklift": "リーチフォークリフト",
  "Crane": "クレーン",
  "Hoist": "ホイスト",
  "Pressure Washer": "高圧洗浄機",
  "Scissor Lift": "シザーリフト",
  "Track Loader": "トラックローダー",
  "ForkLift": "フォークリフト",

  "Project Admin": "プロジェクト管理者",
  "Project Manager": "プロジェクトマネージャー",
  "Project Owner": "プロジェクトオーナー",
  "Project User": "プロジェクトユーザー",
  "Environment Admin": "環境管理者",
  "Equipment Analytics Admin": "機器分析管理者",
  "Project Senior User": "プロジェクト上級ユーザー",
  "Supplier Equipment Coordinator": "サプライヤー機器コーディネーター",
  "View Only": "閲覧のみ",

  role_management: "役割管理",
  role_management_description:
    "役割管理では、組織内のユーザーの役割と権限を定義および管理できます。新しい役割を作成し、特定の権限を割り当てて、ユーザーがシステム内で実行できるアクションを制御できます。これにより、組織内で適切なアクセス制御とセキュリティが確保されます。",
  
  name: "名前",
  role_name: "役割名",
  role_name_required: "役割名必須",
  role_code: "役割コード",
  users_count: "ユーザー数",
  create_role: "新しいロールを作成",
  update_role: "役割の更新",
  permissions: "権限",
  role_created: "新しい役割が作成されました",
  role_permissions_updated: "ロール権限が更新されました",
  roles: "役割",
  total_roles: "合計役割",
  select_all: "すべて選択",

  trade_type: "取引タイプ",
  select_trade_type: "組織の取引タイプを選択",

  flexible_forms: "柔軟なフォーム",
  add_preset_form: "プリセットフォームの追加",
  create_preset_form: "新しいフォームの作成",
  update_preset_form: "フォームの更新",
  order: "注文",
  form: "形状",
  forms: "フォーム",
  preset_form: "プリセットフォーム",
  add_question: "質問を追加",
  add_section: "セクションの追加",
  form_title: "フォームのタイトル",
  form_title_is_required: "フォームのタイトルは必須です",
  location_type: "位置",
  section_title: "セクションのタイトル",
  section_title_is_required: "セクションのタイトルは必須です",
  new_question: "新しい質問",
  no_flex_form: "柔軟なフォームが設定されていません",
  check_in_form: "チェックインフォーム",
  check_out_form: "チェックアウトフォーム",
  booking: "予約",
  checkin: "チェックイン",
  checkout: "チェックアウト",
  form_updated_successfully: "フォームが正常に更新されました",
  form_created_successfully: "フォームが正常に作成されました",
  label: "ラベル",
  question_title: "質問",
  form_deleted_successfully: "フォームが正常に削除されました",
  create_new_form: "新しいフォームの作成",
  please_fill_the_required_fields: "いくつかの必須フィールドが欠落しています",
  save_to_preset_form: "プリセットフォームに保存",
  save_form: "フォームを保存",
  question_is_mandatory: "質問は必須です",
  go_to_section_base_on_answer: "回答に基づいてセクションに移動します",
  continue_to: "続けて",
  delete_preset_form: "プリセットフォームの削除",
  edit_preset_form: "プリセットフォームの編集",
  platform: "プラットフォーム",
  platforms: "プラットフォーム",
  create_platform: "プラットフォームの作成",
  edit_platform: "プラットフォームを編集",
  total_platforms: "合計プラットフォーム",
  description: "説明",
  url: "メールアドレス",
  custom_duration: "カスタム期間",
  webhooks: "ウェブフック",
  events: "イベント",
  listening_for: "聞いている",
  request_filters: "リクエストフィルター",
  total_Webhooks: "合計ウェブフック",
  create_webhook: "ウェブフックの作成",
  by_webhook_events: "Webhookイベント",
  by_webhook_statuses: "Webhookステータス別",
  statuses_selected: "選択されたステータス",
  events_selected: "選択されたイベント",
  requested_at: "要求された日時",
  event: "イベント",
  global_masters: "グローバルマスター",
  equipment_master: "設備マスター",
  vehicle_master: "車両マスター",

  my_account: "マイアカウント",
  account_info: "アカウント情報",
  info: "情報",
  preferences: "設定",
  my_preferences: "マイ設定",
  user_created_at: "ユーザー作成日",
  user_last_update_at: "ユーザー最終更新日",
  projects: "プロジェクト",
  date_format: "日付形式",
  time_format: "時間形式",
  calendar_start_day: "週の開始日",
  select_platform: "プラットフォームを選択",

  // Trade Type translation
  None: "------------------------------------",
  "Existing Building Demolition": "既存建物の解体",
  "CIP concrete, precast concrete, rebar":
    "CIPコンクリート、プレキャストコンクリート、鉄筋",
  CMU: "CMU",
  "Structural Steel Framing, Steel Decking, Cold Formed Metal Framing":
    "構造鋼フレーミング、鋼デッキ、冷間成形金属フレーミング",
  "Rough carpentry": "粗大木工",
  "Thermal insulation for GWB assemblies and roofing, roofing and siding panels, membrane roofing":
    "GWBアセンブリおよび屋根の断熱、屋根およびサイディングパネル、膜屋根",
  "Doors, Frames, Hardware, Interior and Exterior Glazing, Specialty Doors":
    "ドア、フレーム、ハードウェア、内装および外装のガラス、特殊ドア",
  "GWB assemblies, paint & coatings, flooring, acoustical ceilings":
    "GWBアセンブリ、塗料およびコーティング、床材、音響天井",
  "Site concrete and asphalt paving":
    "サイトコンクリートおよびアスファルト舗装",
  "Earthwork & utilities": "土木工事およびユーティリティ",
  "Temporary Construction": "仮設工事",
  "Frame construction": "フレーム工事",
  "Finishing construction": "仕上げ工事",
  "Equipment construction": "設備工事",
  "Miscellaneous construction": "雑工事",

  region_state: "地域/州",

  // System Banners
  system_banners: "システムバナー",
  create_banner: "バナーを作成します",
  edit_banner: "バナーを編集します",
  banner_title: "タイトル",
  banner_message: "メッセージ",
  banner_html_content: "HTMLコンテンツ（オプション）",
  banner_type: "タイプ",
  banner_priority: "優先度",
  banner_display_mode: "表示モード",
  banner_target_type: "ターゲットタイプ",
  banner_start_date: "開始日",
  banner_end_date: "終了日（オプション）",
  banner_detail_url: "詳細URL（オプション）",
  banner_active: "アクティブ",
  banner_dismissible: "解雇可能",
  select_project: "プロジェクトの選択",
  select_organization: "組織の選択",
  all_users: "すべてのユーザー",
  users_with_role: "役割を持つユーザー",
  global_banner: "グローバルバナー",
  after_login_popup: "ログイン後のポップアップ",
  homepage_banner: "ホームページのバナー",
  notification: "通知",
  disaster_alert: "災害警報",
  maintenance: "メンテナンス",
  system_issue: "システムの問題",
  general: "一般的な",
  low: "低い",
  medium: "中くらい",
  high: "高い",
  critical: "致命的",
  banner_created_successfully: "バナーが正常に作成されました",
  banner_updated_successfully: "バナーが正常に更新されました",
  banner_deleted_successfully: "バナーは正常に削除されました",
  failed_to_load_system_banners: "システムバナーの読み込みに失敗しました",
  failed_to_delete_banner: "バナーを削除できませんでした",
  failed_to_save_banner: "バナーを保存できませんでした",
  are_you_sure_delete_banner: "このバナーを削除してもよろしいですか?",
  no_banners_found: "バナーが見つかりませんでした",
  target: "ターゲット",
  update: "アップデート",
  create: "作成する",
  start_date: "開始日",
  end_date: "終了日",
  
  // System Banner Error Messages
  Err_system_banner_mark_as_read_failed: "バナーを既読にマークできませんでした",
  Err_system_banner_mark_as_read_error: "バナーを既読にマークする際にエラーが発生しました",
  all_items_loaded: "すべてのアイテムが読み込まれました",
  total: "合計",
  loading: "読み込み中",
  error_loading_more: "さらにアイテムをロード中にエラーが発生しました",
  retry: "リトライ",
  project_create_under_org: "このプロジェクトは {{org}} の配下に作成されます。",
  project_create_owner_cross_org:
    "自分の組織（{{org}}）のプロジェクトのみ作成できます。このオーナーは {{ownerOrg}} に属しています。",
  Err_can_only_create_for_own_organization:
    "自分の組織のプロジェクトのみ作成できます。",

  // Global Variables (BUGS-504)
  global_variables: "グローバル変数",
  anthropic_key: "Anthropic キー",
  anthropic_model: "Anthropic モデル",
  anthropic_key_help:
    "SCP のすべての AI 機能（Co-pilot、サプライヤーインポート、PO・BOM の PDF チェック、資材分類、EPD 解析）で使用されます。保存したキーが全文表示されることはありません。",
  current_key: "現在のキー",
  new_key: "新しいキー",
  enter_new_anthropic_key: "新しい Anthropic キーを貼り付けてください",
  clear_key: "キーをクリア",
  anthropic_key_clear_confirm:
    "Anthropic キーをクリアしますか？新しいキーを保存するまで SCP の AI 機能は使用できません。",
  key_not_set: "未設定です。キーを保存するまで SCP の AI 機能は使用できません。",
  copilot_model: "Co-pilot モデル",
  copilot_model_help: "Co-pilot、PDF からのサプライヤーインポート、PO・BOM の PDF チェック、EPD 解析で使用されます。",
  categorization_model: "分類モデル",
  categorization_model_help:
    "AI 資材分類のみで使用されます。より安価なモデルを使えるよう、別に設定します。",
  last_updated_by: "最終更新: {{user}}（{{date}}）",
  global_variable_saved: "保存しました。SCP は次の AI リクエストから使用します（最長 10 分以内）。",
  loading_models: "保存したキーで使用できるモデルを読み込んでいます…",
  failed_to_load_models: "使用できるモデルの読み込みに失敗しました",
  go_to_anthropic_key: "Anthropic キーへ移動",
  model_not_in_list: "{{model}}（保存したキーでは使用できません）",
  model_context_window: "コンテキストウィンドウ: {{tokens}} トークン",
  model_max_output: "最大出力: {{tokens}} トークン",
  model_released: "リリース日: {{date}}",
  model_supports: "対応: {{list}}",
  capability_vision: "画像",
  capability_adaptive_thinking: "適応型思考",
  capability_structured_outputs: "構造化出力",
  capability_effort: "エフォート制御",
  Err_anthropic_key_not_set: "先に Anthropic キーを保存してください。モデル一覧はそのキーで読み込まれます。",
  Err_anthropic_key_invalid: "保存したキーが Anthropic に拒否されました。Anthropic キーのページを確認してください。",
  Err_anthropic_unavailable: "Anthropic に接続できませんでした。しばらくしてから再試行してください。",
  Err_model_not_available: "このモデルは保存したキーでは使用できません。",
  Err_model_required: "モデルを選択してください。",
  failed_to_load_global_variables: "グローバル変数の読み込みに失敗しました",
  failed_to_save_global_variable: "変更の保存に失敗しました",
  global_variables_no_access: "グローバル変数を表示できるのは Voyage Control のグローバル管理者のみです。",

  // Inventory Ledger Alerts (BUGS-535)
  inventory_ledger_alerts: "在庫台帳アラート",
  inventory_ledger_alerts_help:
    "夜間の在庫台帳ジョブが失敗した場合、一部失敗した場合、または以前の実行が漏れていたことが判明した場合にメールを受け取る宛先です。メールアドレスを 1 件、または複数件をカンマ区切りで入力してください。共有メールボックスでも個人でも構いません。",
  ledger_alert_recipients: "アラートの宛先",
  current_recipients: "現在の宛先",
  recipients: "宛先",
  enter_ledger_alert_emails: "例: stock-team@company.com, jane.doe@company.com",
  ledger_alerts_not_set: "未設定です。台帳アラートはログにのみ記録されます。",
  ledger_alerts_clear_confirm: "アラートの宛先をクリアしますか？台帳アラートはログにのみ記録されるようになります。",
  ledger_alerts_saved: "保存しました。次回の台帳アラートから適用されます（最長 10 分以内）。",
  clear: "クリア",
  Err_invalid_email_list: "次のメールアドレスは無効です: {{list}}。",
};
export default Translation;
